import React, { useEffect, useState, useContext } from 'react';
import PopupWithForm from '../PopupWithForm/PopupWithForm';
import '../EditProfileModal/EditProfileModal.css';
import { CurrentUserContext } from '../../context/CurrentUserContext';
import MainApi from '../../utils/API/MainApi.js';
import { useTranslation } from '../../utils/hooks/translateHook.js';


function EditProfilePopup({ isOpen, onClose }) {
  const { currentUser, setCurrentUser } = useContext(CurrentUserContext);
  const t = useTranslation();

  const [formData, setFormData] = useState({
    name: '',
    lastname: '',
    email: '',
    country: '',
    city: '',
    phone: '',
  });

  const [formErrors, setFormErrors] = useState({});
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (currentUser) {
      setFormData({
        name: currentUser.name || '',
        lastname: currentUser.lastname || '',
        email: currentUser.email || '',
        country: currentUser.country || '',
        city: currentUser.city || '',
        phone: currentUser.phone || '',
      });
      setFormErrors({});
      setIsButtonEnabled(false);
    }
  }, [currentUser, isOpen]);

  const handleChange = (e) => {
    const { name, value, validity, validationMessage } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: validity.valid ? false : validationMessage }));
  };

  useEffect(() => {
    const valid = Object.keys(formErrors).every((key) => formErrors[key] === false && formData[key]);
    setIsButtonEnabled(valid);
  }, [formErrors, formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      /* const token = localStorage.getItem('token'); */
      const response = await MainApi.updateProfile(formData);
      if (response.user) {
        setCurrentUser(response.user);
        localStorage.setItem('user', JSON.stringify(response.user));
        onClose();
      }
    } catch (error) {
      console.error('Failed to update profile:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PopupWithForm
      title={t('editProfile')}
      name="editprofile"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      buttonText={isLoading ? 'Saving...' : t('saveChanges')}
      isButtonEnabled={isButtonEnabled}
      isLoggedIn={true}
    >
      <label className="popup__formfield">
        <p className="popup__formfield__labeltype">{t('firstName')}</p>
        <input className="popup__input" name="name" type="text" placeholder="Enter first name" value={formData.name} onChange={handleChange} 
        required />
        <span className="popup__input-error">{formErrors.name}</span>
      </label>

      <label className="popup__formfield">
        <p className="popup__formfield__labeltype">{t('lastName').toUpperCase()}</p>
        <input className="popup__input" name="lastname" type="text" placeholder="Enter last name" value={formData.lastname} onChange={handleChange}
          required />
        <span className="popup__input-error">{formErrors.lastname}</span>
      </label>

      <label className="popup__formfield">
        <p className="popup__formfield__labeltype">{t('email').toUpperCase()}</p>
        <input className="popup__input" name="email" type="email" placeholder="Enter email" value={formData.email} onChange={handleChange} 
        required />
        <span className="popup__input-error">{formErrors.email}</span>
      </label>

      <label className="popup__formfield">
        <p className="popup__formfield__labeltype">{t('country').toUpperCase()}</p>
        <input className="popup__input" name="country" type="text" placeholder="Enter country" value={formData.country} onChange={handleChange}
          required />
        <span className="popup__input-error">{formErrors.country}</span>
      </label>

      <label className="popup__formfield">
        <p className="popup__formfield__labeltype">{t('city').toUpperCase()}</p>
        <input className="popup__input" name="city" type="text" placeholder="Enter city" value={formData.city} onChange={handleChange} 
          required />
        <span className="popup__input-error">{formErrors.city}</span>
      </label>

      <label className="popup__formfield">
        <p className="popup__formfield__labeltype">{t('phone').toUpperCase()}</p>
        <input className="popup__input" name="phone" type="text" placeholder="Enter phone" value={formData.phone} onChange={handleChange}
          required />
        <span className="popup__input-error">{formErrors.phone}</span>
      </label>
    </PopupWithForm>
  );
}

export default EditProfilePopup;
